import { render, staticRenderFns } from "./ContentForm.vue?vue&type=template&id=01719b3e&scoped=true&"
import script from "./ContentForm.vue?vue&type=script&lang=js&"
export * from "./ContentForm.vue?vue&type=script&lang=js&"
import style1 from "./ContentForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01719b3e",
  null
  
)

export default component.exports